import React, {useContext} from 'react'
import {GlobalLangCtx} from '../../App'
import BorderComp from '../BorderComp/BorderComp'
import GitHubImage from '../ImgLinksProject/GithubSgv'
import HerokuImage from '../ImgLinksProject/HerokuSvg'
import "./FrameName.css"

// import "../ImgLinksProject/GitHubStyleLogo.css"

const FrameName = () =>{

       const [selLan] = useContext(GlobalLangCtx);
       const fLan = require (`../language_app/json_files/lang[${selLan}].json`)
 
    return(
        <section id='mainFrameContainer'>
            <div className="blocks">
                <div className='frameFullName'>
                    <h1>
                        <span>Giuseppe</span> <span> Tarallo </span>
                    </h1>
                    <div className='subTitle'>
                        <h4>
                            web and development
                        </h4>
                    </div>

                </div>

                <div className='boxBorderComp'>
                            <BorderComp />
                </div>
            </div>
            <div id="linkBlk">

                <div className='frameLinks'>
                    <div className='frame_lnkImgs'>
                        <a title={fLan.linkProjetOnLine.githubTitle} href="#projectComp">
                            {<HerokuImage />}
                        </a>
                    </div>
                    <div className='frame_lnkImgs'>
                        <a title={fLan.linkProjetOnLine.herokuTitle} rel="noreferrer" target='_blank' href="https://github.com/pippo-github?tab=repositories">
                            {<GitHubImage />} 
                       </a>
                    </div>
            </div>

            </div>
        </section>
    )

}

export default FrameName